import { useState } from 'react';
import { Link, useLocation } from 'react-router';

import Input from '@cartwhl/ui/atoms/Input';
import Text from '@cartwhl/ui/base/Text';
import GoogleIcon from '@cartwhl/ui/icons/GoogleIcon';
import Button from '@cartwhl/ui/input/Button';
import GoButton from '@cartwhl/ui/input/GoButton';

import { authStore } from 'stores/global';

import AuthPageLayout from './AuthPageLayout';

export default function LoginPage() {
  const [loading, setLoading] = useState(false);
  const { search } = useLocation();

  return (
    <AuthPageLayout title="Sign in">
      <form
        className="grid grid-cols-2 gap-x-4 gap-y-6 pb-7"
        onSubmit={async (e) => {
          e.preventDefault();
          const email = e.currentTarget.email.value;
          const password = e.currentTarget.password.value;
          setLoading(true);
          await authStore.loginWithPassword(email, password);
          setLoading(false);
        }}
      >
        <Input
          label="Your email"
          type="email"
          name="email"
          placeholder="Email"
          autoComplete="email"
          className="col-span-2"
        />
        <div className="col-span-2">
          <Input
            label="Your password"
            name="password"
            type="password"
            autoComplete="password"
            placeholder="Password"
          />
          <Link
            to="/request-password-reset"
            className="text-tertiary mt-2 inline-block hover:underline"
          >
            <Text variant="studio/body/sm">Forgot password?</Text>
          </Link>
        </div>
        <GoButton loading={loading} type="submit" className="col-span-2">
          Sign in
        </GoButton>
      </form>
      <Text
        variant="studio/body/sm"
        as="div"
        className="text-tertiary mb-3 text-center"
      >
        Don't have an account?{' '}
        <Link
          to={`/sign-up${search}`}
          className="text-green-50 hover:underline"
        >
          Try it for free
        </Link>
      </Text>
      <Text
        variant="studio/body/medium/sm"
        as="div"
        className="relative mb-5 text-center"
      >
        <hr className="border-primary absolute left-0 right-0 top-1/2 -z-10" />
        <Text
          variant="studio/body/sm"
          className="text-tertiary bg-primary px-1"
        >
          or
        </Text>
      </Text>
      <div className="mb-6 flex justify-center">
        <Button
          variant="primary"
          icon={<GoogleIcon />}
          onClick={() => void authStore.continueWithGoogle({ intent: 'login' })}
        >
          Continue with Google
        </Button>
      </div>
    </AuthPageLayout>
  );
}
